<template>
  <div class="page">
    <div class="nav">
      <span
        :class="selected == '月分析' ? 'selected' : ''"
        @click="toggle('月分析')"
        >月分析</span
      >
      <span>|</span>
      <span
        :class="selected == '日分析' ? 'selected' : ''"
        @click="toggle('日分析')"
        >日分析</span
      >
      <span>|</span>
      <span
        :class="selected == '明细' ? 'selected' : ''"
        @click="toggle('明细')"
        >明细</span
      >
      <span>|</span>
      <span
        :class="selected == '预测' ? 'selected' : ''"
        @click="toggle('预测')"
        >预测</span
      >
    </div>

    <out-month v-if="selected == '月分析'" @toggle="toggle" />

    <out-day v-if="selected == '日分析'" @toggle="toggle"/>

    <sale-out v-if="selected == '明细'" :condition="condition" />
    <prediction v-if="selected == '预测'"/>
    <!-- <forcast v-if="selected == '预测'" /> -->
  </div>
</template>

<script>
import OutMonth from "@/components/OutMonth/OutMonth.vue";
import OutDay from "@/components/OutMonth/OutDay.vue";
import SaleOut from "@/components/OutMonth/SaleOut.vue";
import Prediction from "@/components/OutMonth/Prediction.vue";


export default {
  components: {
    OutMonth,
    OutDay,
    SaleOut,
    Prediction,
  },
  data() {
    return {
      selected: "月分析",
      condition: null,
    };
  },
  methods: {
    toggle(val, data) {
      this.selected = val;

      if (val == "明细" && data) {
        this.condition = data;
      }else{
        this.condition = null
      }
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
@media screen and (min-width: 500px) {
  .nav{
    display: none;
  }
}
</style>